import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h4", null, "Hinnateavitused", -1)
const _hoisted_2 = {
  key: 1,
  class: "text-danger validation-summary-errors",
  "data-valmsg-summary": "true"
}
const _hoisted_3 = { class: "col-2" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "col-6" }
const _hoisted_7 = { class: "small" }
const _hoisted_8 = { class: "col-2" }
const _hoisted_9 = { class: "col-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isAuthenticated)
      ? (_openBlock(), _createBlock(_component_Header, {
          key: 0,
          title: "",
          back: "home"
        }))
      : _createCommentVNode("", true),
    _hoisted_1,
    (_ctx.errorMsg != null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, _toDisplayString(_ctx.errorMsg), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAlarm(), (item) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.id,
        class: "border p-2 mb-4 row"
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            src: _ctx.getProductImageByBarcode(item.product.barcode),
            alt: "product"
          }, null, 8, _hoisted_4),
          _createElementVNode("button", {
            class: "small",
            onClick: ($event: any) => (_ctx.clickRemove(item.id))
          }, "x", 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_RouterLink, {
            to: { name: 'product-details', params: { id: item.productId } },
            class: "text-dark"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.product.name), 1)
            ]),
            _: 2
          }, 1032, ["to"]),
          _createElementVNode("div", _hoisted_7, _toDisplayString(item.product.barcode), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_RouterLink, {
            to: { name: 'product-details', params: { id: item.productId } },
            class: "text-dark"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" €" + _toDisplayString(item.product.minPrice), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ]),
        _createElementVNode("div", _hoisted_9, " €" + _toDisplayString(item.minValue), 1)
      ]))
    }), 128))
  ], 64))
}